<template>
    <div>
    </div>
</template>

<script>
export default {
  name: 'error',
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/views/Error.vue